// test386
(386 && 0);
